"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiEmployeeLocationUnfollowAllResponse = instanceOfApiEmployeeLocationUnfollowAllResponse;
exports.ApiEmployeeLocationUnfollowAllResponseFromJSON = ApiEmployeeLocationUnfollowAllResponseFromJSON;
exports.ApiEmployeeLocationUnfollowAllResponseFromJSONTyped = ApiEmployeeLocationUnfollowAllResponseFromJSONTyped;
exports.ApiEmployeeLocationUnfollowAllResponseToJSON = ApiEmployeeLocationUnfollowAllResponseToJSON;
exports.ApiEmployeeLocationUnfollowAllResponseToJSONTyped = ApiEmployeeLocationUnfollowAllResponseToJSONTyped;
/**
 * Check if a given object implements the ApiEmployeeLocationUnfollowAllResponse interface.
 */
function instanceOfApiEmployeeLocationUnfollowAllResponse(value) {
    if (!('unfollowedCount' in value) || value['unfollowedCount'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('success' in value) || value['success'] === undefined)
        return false;
    return true;
}
function ApiEmployeeLocationUnfollowAllResponseFromJSON(json) {
    return ApiEmployeeLocationUnfollowAllResponseFromJSONTyped(json, false);
}
function ApiEmployeeLocationUnfollowAllResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'unfollowedCount': json['unfollowed_count'],
        'status': json['status'],
        'success': json['success'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}
function ApiEmployeeLocationUnfollowAllResponseToJSON(json) {
    return ApiEmployeeLocationUnfollowAllResponseToJSONTyped(json, false);
}
function ApiEmployeeLocationUnfollowAllResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'unfollowed_count': value['unfollowedCount'],
        'status': value['status'],
        'success': value['success'],
        'message': value['message'],
    };
}
